module.exports = __webpack_public_path__ + "img/apidays-hongkong-2022-video-cover.5a4f6fcf.jpg";